"use client";

import { c as _c } from "react/compiler-runtime";
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  number?: FieldConfig;
  text?: FieldConfig;
};
export default function HorizontalCricketCommentryBallNews(t0) {
  const $ = _c(15);
  const {
    number: t1,
    text: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {
      hidden: false,
      value: "0",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const number = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? {
      hidden: false,
      value: "17.4 \u0B9F\u0BC6\u0B9F\u0BCD\u0BB0\u0BC1\u0BA4\u0BCD\u0B95\u0BC1 \u0BAA\u0BBF \u0B9C\u0BC6\u0BAF\u0B9A\u0BC2\u0BB0\u0BBF\u0BAF\u0BBE, \u0B9A\u0BA3\u0BCD\u0BAE\u0BC1\u0B95\u0BBE\u0BB3\u0BBF\u0BAE\u0BCD \u0B9A\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BA9\u0BBE\u0BB0\u0BCD! \u0B9F\u0BC6\u0B95\u0BCD\u0B95\u0BB0\u0BCD \u0BA4\u0BA9\u0BA4\u0BC1 \u0BB5\u0BBF\u0B95\u0BCD\u0B95\u0BC6\u0B9F\u0BCD\u0B9F\u0BC8 \u0BA4\u0BC2\u0B95\u0BCD\u0B95\u0BBF \u0B8E\u0BB1\u0BBF\u0BA8\u0BCD\u0BA4\u0BBE\u0BB0\u0BCD. \u0BB5\u0BBF\u0B95\u0BCD\u0B95\u0BC6\u0B9F\u0BCD\u0B9F\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC0\u0BB4\u0BC7 \u0BA8\u0B9F\u0BA9\u0BAE\u0BBE\u0BB1\u0BCD\u0B95\u0BBF\u0BB1\u0BBE\u0BB0\u0BCD \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0BB2\u0BBE\u0B95\u0BCD\u0BAA\u0BC0\u0B9F\u0BCD \u0BB7\u0BBE\u0B9F\u0BCD\u0B9F\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B9A\u0BC6\u0BB2\u0BCD\u0B95\u0BBF\u0BB1\u0BBE\u0BB0\u0BCD, \u0B86\u0BA9\u0BBE\u0BB2\u0BCD \u0BA4\u0BC7\u0BB5\u0BC8\u0BAF\u0BBE\u0BA9 \u0B89\u0BAF\u0BB0\u0BA4\u0BCD\u0BA4\u0BC8 \u0BAA\u0BC6\u0BB1\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8. \u0BAE\u0BBF\u0B9F\u0BCD-\u0B86\u0BA9\u0BCD \u0BAA\u0BAF\u0BB0\u0BCD\u0B9A\u0BCD\u0B9A\u0BB2\u0BBF\u0BB2\u0BCD \u0B9A\u0BA3\u0BCD\u0BAE\u0BC1\u0B95\u0BBE\u0BB2\u0BCD \u0B92\u0BB0\u0BC1 \u0B85\u0BB1\u0BCD\u0BAA\u0BC1\u0BA4\u0BAE\u0BBE\u0BA9 \u0B95\u0BC7\u0B9F\u0BCD\u0B9A\u0BCD \u0BAE\u0BC1\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BBE\u0BA9\u0BCD, \u0B85\u0BA4\u0BC8 \u0BAE\u0BC1\u0BB4\u0BC1\u0BAE\u0BC8\u0BAF\u0BBE\u0B95 \u0B87\u0BA9\u0BC8\u0B95\u0BC8\u0B95 \u0BAE\u0BC1\u0BAF\u0BC1\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const text = t4;
  const numberValue = number?.value || "0";
  const textValue = text?.value || "";
  let t5;
  if ($[4] !== number?.customClass || $[5] !== number?.hidden || $[6] !== numberValue) {
    t5 = !number?.hidden && <div className={`w-8 h-8 bg-blue-700 rounded flex items-center justify-center flex-shrink-0 ${number?.customClass || ""}`}><span className="text-FFFFFF font-bold text-sm">{numberValue}</span></div>;
    $[4] = number?.customClass;
    $[5] = number?.hidden;
    $[6] = numberValue;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== text?.customClass || $[9] !== text?.hidden || $[10] !== textValue) {
    t6 = !text?.hidden && <div className="flex-1"><p className={`text-1B1B1B text-16-tamil-400 leading-[1.6] line-clamp-4 ${text?.customClass || ""}`}>{textValue}</p></div>;
    $[8] = text?.customClass;
    $[9] = text?.hidden;
    $[10] = textValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="bg-gray-50 p-4"><div className="flex gap-4">{t5}{t6}</div></div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}